// extracted by css-extract-rspack-plugin
export default {"email":"_2nGQPH8F92piqL4Dfxo9Gb","icon":"_1JmLYPH034m9L91WzlM0iU","checkboxes":"_3AYPD3ic0NfZJOUN2NQ2KJ"};